import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { IUnitControlQueueBasicModel } from '@apps-common/types/portal/unit-control'

export const getUnitControlProgramHistory = async (unitId: string, skip: number, take: number): Promise<IUnitControlQueueBasicModel[]> =>
  axios.get(`/unitcontrol/getprogramminghistorybyunit?unitId=${unitId}&skip=${skip}&take=${take}`).then((res) => res.data?.data)

type Props = {
  unitId: string
  take: number
  enabled?: boolean
}

export const useGetUnitControlProgramHistory = ({ unitId, take, enabled }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage } = useInfiniteQuery({
    ...{ cacheTime: 0 },
    queryKey: ['getUnitControlProgramHistory', unitId, take],
    initialPageParam: 0,
    queryFn: ({ pageParam = 0 }) => getUnitControlProgramHistory(unitId, pageParam, take),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < take) {
        return null
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: ['getUnitControlProgramHistory'] })
    },
    []
  )

  return { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage }
}
